import { useShortLocale } from '#configuration/lang/useLocale.ts';

export const useLocaleManualLink = () => {
    const locale = useShortLocale();
    return `https://rio.cloud/${locale}/documents/order-communication/how-to/user-manual`;
};
